import React from 'react'

const customerManagement = () => {
  return (
    <div className="container-fluid" >
    {/* Welcome Card */}
    <div className="row mb-4">
        <div className="col-12">
            <div className="card" style={{ 
                background: "linear-gradient(to right, #0e0b2b, #0e0b2b)", 
                borderRadius: "15px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                border: "none"
            }}>
                <div className="row align-items-center p-4">
                    <div className="col-md-7">
                        <div className="p-3">
                            <h4 className="text-white-50">Customer Management</h4>
                           
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
    
  

   

  
</div>
  )
}

export default customerManagement